import React, { useState, useRef, useEffect } from 'react';
import { Check, ChevronDown } from 'lucide-react';
import './CustomSelect.css';

/**
 * CustomSelect — dropdown tuỳ chỉnh đẹp, không dùng <select> mặc định
 * Props:
 *   options: [{ value, label }]
 *   value: string (giá trị đang chọn)
 *   onChange: fn(value)
 *   placeholder: string (optional)
 */
const CustomSelect = ({ options = [], value, onChange, placeholder = 'Chọn...' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = options.find((o) => o.value === value);

  // Đóng khi click ngoài
  useEffect(() => {
    const onOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onOutside);
    return () => document.removeEventListener('mousedown', onOutside);
  }, []);

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  return (
    <div className={`cs-root ${open ? 'is-open' : ''}`} ref={ref}>
      {/* Trigger */}
      <button
        type="button"
        className="cs-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="cs-value">
          {selected ? selected.label : <span className="cs-placeholder">{placeholder}</span>}
        </span>
        <ChevronDown className="cs-chevron" size={16} />
      </button>

      {/* Dropdown panel */}
      <ul className="cs-panel" role="listbox">
        {options.map((opt) => {
          const isActive = opt.value === value;
          return (
            <li
              key={opt.value}
              className={`cs-option ${isActive ? 'is-active' : ''}`}
              role="option"
              aria-selected={isActive}
              onClick={() => handleSelect(opt.value)}
            >
              <span className="cs-option-label">{opt.label}</span>
              {isActive && <Check size={14} className="cs-check" />}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CustomSelect;
